module.exports = __webpack_public_path__ + "img/Secured-by-pci-dss.5c92466d.png";